import { NUMBER_SEQUENCE_RESET_PERIODS } from "@artisancode/api-types";
import { z } from "zod";

export const VALID_PLACEHOLDER_KEYS = [
  "Year",
  "Y",
  "Month",
  "Day",
  "ExtBranchId",
] as const;

export function validateSequencePlaceholders(
  str: string,
  isPrefix: boolean,
): boolean {
  if (!str) return true;
  if (isPrefix && str.startsWith("/")) {
    return false;
  }

  const matches = Array.from(str.matchAll(/%\(([^)]+)\)(s)?/g));
  if (matches.length === 0) return true;

  for (const m of matches) {
    const key = m[1];
    if (
      !VALID_PLACEHOLDER_KEYS.includes(
        key as (typeof VALID_PLACEHOLDER_KEYS)[number],
      )
    ) {
      return false;
    }

    const start = m.index ?? 0;
    const end = start + m[0].length;
    const isFirst = start === 0;
    const isLast = end === str.length;
    const prevChar = start > 0 ? str[start - 1] : "";
    const nextChar = end < str.length ? str[end] : "";

    if (key === "ExtBranchId") {
      if (isFirst && nextChar !== "/") return false;
      if (isLast && prevChar !== "/") return false;
      if (!isFirst && !isLast && (prevChar !== "/" || nextChar !== "/"))
        return false;
    }
  }

  return true;
}

export const numberSequenceSchema = z
  .object({
    moduleCode: z.string().min(1, "Kode modul harus diisi"),
    name: z.string().min(1, "Nama dokumen harus diisi"),
    prefix: z.string(),
    suffix: z.string(),
    size: z.number().int().min(1).max(10),
    step: z.number().int().min(1),
    next: z.number().int().min(1),
    resetPeriod: z.enum(NUMBER_SEQUENCE_RESET_PERIODS),
    autoGenerateOnCreate: z.boolean(),
  })
  .superRefine((data, ctx) => {
    if (!validateSequencePlaceholders(data.prefix, true)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["prefix"],
        message:
          "Prefix tidak boleh diawali slash (/), dan placeholder %(ExtBranchId)s harus diapit slash (/). Placeholder valid: %(Year)s, %(Y)s, %(Month)s, %(Day)s, %(ExtBranchId)s",
      });
    }

    if (!validateSequencePlaceholders(data.suffix, false)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        path: ["suffix"],
        message:
          "Placeholder suffix harus valid dan %(ExtBranchId)s harus diapit slash (/)",
      });
    }
  });

export type NumberSequenceFormValues = z.infer<typeof numberSequenceSchema>;
